import styled from 'styled-components';
import Bar from './Bar';
import { getColor } from 'core/utils';
import { Input as Inp, Label } from '../Input/inputStyles';

export const PowerContainer = styled.div`
	display: none;
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	border-radius: 4px;
	overflow: hidden;
`;

export const PswPower = styled(Bar)`
	display: block;
	width: 100%;
	height: 5px;
`;

export const Input = styled(Inp)`
	/* stylelint-disable */
	&[required]:valid + ${Label} + ${PowerContainer},
	&:focus + ${Label} + ${PowerContainer} {
		display: block;
	}

	&:focus + ${Label} + ${PowerContainer} {
		border-bottom: 2px solid ${getColor('pelorous')};
		border-left: 2px solid ${getColor('pelorous')};
		border-right: 2px solid ${getColor('pelorous')};
	}
	/* stylelint-enable */
`;
